'use strict';

module.exports = [
    'a'
  , 'abbr'
  , 'acronym'
  , 'b'
  , 'br'
  , 'code'
  , 'em'
  , 'font'
  , 'i'
  , 'img'
  , 'ins'
  , 'kbd'
  , 'map'
  , 'samp'
  , 'small'
  , 'span'
  , 'strong'
  , 'sub'
  , 'sup'
];


/*****************
 ** WEBPACK FOOTER
 ** ./~/pug-parser/lib/inline-tags.js
 ** module id = 184
 ** module chunks = 0
 **/